import { LoadingOverlay, Box, Card, Flex, SimpleGrid, Title, Text } from '@mantine/core';

import { statisticsGroups, statisticsTitles } from '../utils/const/common';
import { convertStatisticsToView } from '../utils/helpers/converter';

import type { TStatistics } from '../store/types';

type Props = {
  items: TStatistics[];
  isLoading?: boolean;
};

export const Statistics = (props: Props) => {
  const {
    items,
    isLoading,
  } = props;

  return (
    <Box style={{ position: 'relative' }} mt={10}>
      <LoadingOverlay
        visible={isLoading}
        overlayProps={{ blur: 2 }}
      />

      {!isLoading && items.length === 0 && (
        <Text>Нет данных</Text>
      )}

      <SimpleGrid cols={{ base: 1, md: 2, lg: 3 }}>
        {convertStatisticsToView(items).map((item) => (
          <Card key={item.currency} withBorder shadow="sm" radius="md">
            <Title size={18} mb={10}>{item.currency}</Title>

            {statisticsGroups.map((group) => (
              <Box key={group.title} mb={10}>
                <Text size="sm" c="dimmed" mb={5}>{group.title}</Text>

                {group.fields.map((field) => (
                  <Flex key={field} justify={'space-between'} gap={10} mb={5} style={{ borderBottom: '1px solid #ddd' }}>
                    <Text>{statisticsTitles[field]}</Text>
                    <Text fw={'bold'} style={{ whiteSpace: 'nowrap' }}>{item[field]}</Text>
                  </Flex>
                ))}
              </Box>
            ))}
          </Card>
        ))}
      </SimpleGrid>
    </Box>
  );
};
